// frontend/packages/business-console/src/hooks/useOnlineStatus.js
//
// Wraps `navigator.onLine` + the `online` / `offline` window events as
// a React-friendly hook. Returns `true` when the browser believes it
// can reach the network — *not* an end-to-end ping. False negatives
// are possible on captive-portal Wi-Fi etc.; the outbox replay layer
// double-checks by actually trying the request.

import { useEffect, useState } from 'react';

function readInitial() {
  if (typeof navigator === 'undefined') return true;
  return navigator.onLine !== false;
}

export default function useOnlineStatus() {
  const [online, setOnline] = useState(readInitial);

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    const goOnline = () => setOnline(true);
    const goOffline = () => setOnline(false);
    window.addEventListener('online', goOnline);
    window.addEventListener('offline', goOffline);
    return () => {
      window.removeEventListener('online', goOnline);
      window.removeEventListener('offline', goOffline);
    };
  }, []);

  return online;
}
